<template>
    <body>
    <router-view></router-view>
    </body>
</template>

<script>
    export default {
        name: "App"
    };
</script>
 

 